module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Chapter 1")]), _vm._v(" "), _c('h1', [_vm._v("Sadie")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-a"
  }, [_vm._v("A")]), _vm._v("S THE SUMMER HEAT")]), _vm._v(" faded away, leaving beautiful autumn days that were refreshing and invigorating, Sadie spent more and more time at her hometown bakery.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Fortune Falls in the fall, she thought.  "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("It doesn’t get better than this.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("While the days were busy and sometimes even hectic as the townspeople came by to pick up their delectable pastries for weekend dinners and get togethers, it was always a pleasure being there.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The days were satisfying and the nights restful and replenishing.  It was exactly what she needed after several weeks of almost nonstop travel.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("There was something about being at her first bakery, of putting her hands into the dough, of making, creating and then sharing her creations with those around her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("After a quick two weeks her energy was fully restored and she felt renewed.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You have everything here under control, Beatrice?” Sadie said as she pulled off her apron.  “I’m going to go to the market.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Everything is fine and dandy,” the older woman said with a cheery grin,  “The tarts will be coming out of the oven in five minutes, and I’m getting started on a new batch of cookie dough.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Great.”  Sadie grabbed her purse off a hook.  “I’ll be back in a bit.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In need of fresh berries for a new recipe she was developing, she headed out.  It was a very chilly but sunny Tuesday morning that greeted her as she walked out onto the wide sidewalk of the small town that was so familiar to her.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Several townspeople walked about, running errands or heading off for an early lunch.  As always, the scents and sounds around her soothed her like a warm blanket.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Heading to the right in the hopes of buying blueberries and raspberries, she ran into Gordy, the Fortune Falls postal worker who still delivered mail on foot.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What perfect timing running into you this morning, Sadie” he said, going through his bag.  “I have something for you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“For me?”  She couldn’t remember the last time she’d received snail mail.  For the most part, Gordy delivered the mail to the few residents who rejected the internet, plus the occasional piece of junk mail.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yep,” Gordy said.  “And I won’t have to go all the way out to your house to deliver it.”  He pulled out a fancy looking stiff envelope.  “Looks important,” he said as he handed it to her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Puzzled, Sadie looked at the golden envelope with her name and address elegantly written in black ink.  Looking for the return address, she flipped the envelope over.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Jolly ole England,” Gordy said, reading the return address over her shoulder.  “Is the queen herself requesting your presence?  A royal wedding perhaps.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie smiled at him as she ran her hand over the expensive paper of the envelope.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well,” he said.  “Aren’t you going to open it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Maybe later,” she said after a moment’s hesitation.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Disappointed, Gordy shrugged.  “Well then, I’ll leave you to it and be on my way.”  He waited a moment as if hoping Sadie would change her mind and open the envelope.  With a final shrug, he walked off and continued with his route.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Finally alone, Sadie opened the envelope and pulled out a card made of handcrafted recycled paper.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("My lovely friend, Sadie,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Pardon the pomp and circumstance, but this latest development in my life has left me feeling regal and renewed.  Having inherited my family’s English castle, I’ve spent the last two weeks in England, eager to make major changes to the castle.  I’ve always dreamed of owning and operating an inn.  This is my chance.  I would love your input, your keen eye and your flawless taste.  You’d receive the princess treatment while here.  Hoping you’ll say yes, I’ve already reserved a plane ticket and am eagerly awaiting your arrival.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Please say yes.  I need you.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Sincerely, your loyal friend, Blakely.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie reread the invitation three times before slipping the fancy card back into the envelope.  Smiling, she looked up at the sky, contemplating this new adventure.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Blakely had been managing Sadie’s New York bakery for the past two years and had always been a hard working and loyal employee.  But two weeks earlier, Blakely found out she had inherited a castle in England and had decided to move there and turn the castle into an inn.  She gave Sadie her resignation the same day she heard about her inheritance, which made Sadie a little sad but happy at the same time. She had grown to known and like Blakely as her employee but also as a friend.  So now Blakely wanted her to come out to England. England, Sadie thought with a smile.  It sure would be nice to go spend a few weeks in England.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Pulling out her phone, Sadie went through her contacts and found Blakely and made the call.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Hello,” Blakely said, a hint of a force British accent coloring her voice slightly.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Of course I’ll come to England,” Sadie said, getting straight to the point.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("There was a moment of silence.  “Sadie?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yep.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh!  Sadie!” Blakely said, suddenly excited with the realization of what the call was for.  “You’ll come?  Oh.  That’s great.  I can’t wait to see you.  I can’t wait for you to see my castle.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why the fancy invitation?  You could have just called me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know.  But there’s just something so... oh, I don’t know...  royal, so regal, so refined about being out here.  I feel romantic.  I feel thrown back in time.  There’s something about this old world life that pushed me to return to older ways.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sadie chuckled, amused by the clash of the old and new world technologies.  “And now I’m going to get on a plane and fly to you in a few hours.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well, there’s only so much the old world way can do.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("They laughed and Sadie was suddenly eager to get on that plane.  “When is this flight that you’ve reserved for me?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Tomorrow morning.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Anything in particular you want me to bring?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Just your brilliant self, your good taste, your wisdom and your friendship.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll pack all of the above and see you soon.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Perfect.  I’ll have a rental car ready and waiting for you at the airport.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Amused by the whole unexpected turn of events, Sadie let out a light laugh.  “Okay.  Bye.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She continued to smile and chuckle as she went to the market, picked up the berries that she needed, then returned to the bakery.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("While she managed to work efficiently the rest of the day, her mind and heart were already on the planning of her trip.  By the time the day ended and she headed home, she’d mentally packed her suitcase, knowing exactly what she wanted to bring.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Get ready, guys,” she said as she walked into the cute country house that she shared with Orchid and Biscuit.  “We’re going on a trip.  Hoping the pond, as they say.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His tail wagging furiously, Biscuit came to her, yapping all the way.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That’s right,” Sadie said as she scratched Biscuit behind the ear.  “You’ve been cooped up in the house for a little too long now.  It’s time you two got out a bit.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Forever nonchalant and laid back, Orchid slowly got out of the cushioned basket she slept in, stretched out her feline limbs then slowly came to Sadie.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Aren’t you excited, Orchid?  We’re going to England.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Meow.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ll take that as a yes.”  She looked at Biscuit.  “What about you?  Are you excited?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Woof.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Now, that’s a definite yes.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She set her purse on the small table by the entryway, then headed into the kitchen to feed the pooch and kitty that relied on her.  With their dishes filled, she made her way to her bedroom to pack a few stylish outfits and some more laid back items.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She lugged her big pick suitcase out of the depths of her closet, pulled it up onto her bed and flicked it open.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Black leggings go with everything,” she said as she pulled them out of her drawer and set them in her big pink suitcase.  “So, it’s for sure you’re coming with me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She then turned to her closet.  “A cute deep blue sweater dress goes everywhere,” she said.  “A gray pencil skirt, a black turtleneck sweater and a red cardigan.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Setting the garments in her suitcase, she considered the weather.  “Must have a raincoat, right?  Maybe a few warm sweatshirts.  Jeans go everywhere and with everything.  And...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Muttering to herself, she continued filling her suitcase until nothing else fit, clipped it shut, dragged it off the bed then rolled it out to the living room.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Orchid, forever wise and perceptive, sat tall and proud as she looked at her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Don’t worry,” she told the feline.  “You’ll have your comfy carrying case and snacks.  And you’re going to love staying in this castle.  There’s so much room to roam around.  It’ll be great.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Overly excited, Biscuit came running to Sadie, almost knocking Orchid over in the process.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Cool it, Biscuit,” Sadie said with a laugh.  “We’re only leaving tomorrow morning.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Yapping with continued excitement, Biscuit ran circles around her then darted to the door and ran back to her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh, right,” Sadie said as she headed to the coat rack where his leash hung.  She clipped it to his collar then turned to Orchid.  “Want to come along?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With a nonchalant gaze, Orchid licked her paw, clearly uninterested in a walk.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Suit yourself,” Sadie said as she opened the door and stepped out. “We’ll be back in a bit.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Walking briskly, she led Biscuit down the quiet country road, letting him stop here and there to smell whatever he felt the need to smell.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Her thoughts went to Blakely and this new chapter in her life.  What a change.  Only weeks earlier she’d been Sadie’s best manager, working at the New York bakery with such ease and finesse.  Now, she owned a huge castle in England.  Who would have thought?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Blakely said that she has long dreamed of turning that castle into a hotel,” Sadie told Biscuit as they walked on.  “Knowing her, she’ll succeed... no problem.  Did I tell you that she wants my opinion on some of the renovations she’s already done?  That’s right.  She trusts my opinion.  Isn’t that a hoot?  Anyway, it’s certainly very flattering.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Uninterested in her story, Biscuit barked, his sign that they’d gone far enough and he was ready to head back.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay,” Sadie said with a chuckle.  “I’m eager to get back home, too.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0